/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespNullSearchResults_viewer = {
    readonly isShopByRoomEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespFollowSearchBanner_viewer" | "SbSharedNullSearchRelatedItems_viewer">;
    readonly " $refType": "SbRespNullSearchResults_viewer";
};
export type SbRespNullSearchResults_viewer$data = SbRespNullSearchResults_viewer;
export type SbRespNullSearchResults_viewer$key = {
    readonly " $data"?: SbRespNullSearchResults_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespNullSearchResults_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespNullSearchResults_viewer",
  "selections": [
    {
      "alias": "isShopByRoomEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SHOP_BY_ROOM"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedNullSearchRelatedItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '7f4fb3c86242833cad0a4dc5d93852d8';
export default node;
